
import { getApiClient } from '../client';
import { handleApiError } from '../utils/handleApiError';
import type { ServiceResponse } from '@dopomogai/types';
import type {
  HandoverQueueResponse,
  ClaimResponse,
  ReleaseResponse,
  OperatorMessagePayload,
} from '@dopomogai/types';

export const operatorService = {
  getHandoverQueue: (limit = 50, offset = 0): ServiceResponse<HandoverQueueResponse> => {
    return getApiClient()
      .get<HandoverQueueResponse>('/operator/handover-queue', { params: { limit, offset } })
      .then(res => res.data)
      .catch(err => handleApiError(err, 'fetching handover queue'));
  },

  claim: (conversationId: string): ServiceResponse<ClaimResponse> => {
    return getApiClient()
      .post<ClaimResponse>(`/operator/conversations/${conversationId}/claim`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `claiming conversation ${conversationId}`));
  },

  release: (conversationId: string): ServiceResponse<ReleaseResponse> => {
    return getApiClient()
      .post<ReleaseResponse>(`/operator/conversations/${conversationId}/release`)
      .then(res => res.data)
      .catch(err => handleApiError(err, `releasing conversation ${conversationId}`));
  },

  sendMessage: (conversationId: string, payload: OperatorMessagePayload): ServiceResponse<{ status: 'success' }> => {
    return getApiClient()
      .post(`/operator/conversations/${conversationId}/message`, payload)
      .then(() => ({ status: 'success' } as const))
      .catch(err => handleApiError(err, `sending operator message to ${conversationId}`));
  },
};